import React from "react";
import Slider from "./Slider";
import SupportedWallets from "./Supportwallet";






const Mainsection =()=>{
    return(
     
        <>
        
<Slider/>
      <>
  {/* News Section Start */}
  <section className="collection-wrap pt-50 pb-50">
    <img
      src="assets/img/section-shape-1.png"
      alt="Image"
      className="section-shape"
    />
    <div className="container">
      <div className="row">
        <div className="col-lg-8"align="left" >
          <div className="section-title style1 mb-40">
            <h2>Financial technology at Meta Benz</h2>
            <h5 className="text-white">
              The value we provide to our customers &amp; our markets
            </h5>
            <p className="text-white">
              We are an organisation, driven by values. A company which is run
              by its values is a company which will always achieve its goals.
              Given below are our values, we religiously believe in and strictly
              follow, at our work and in our life. Our purpose describes our
              role in this world, the value we provide to our customers and our
              markets, and the commitments we have made to our employees and
              stakeholders.
            </p>
            <p className="text-white">
              Our values serve as our ethical and moral compass and describe how
              we should behave with each other and our customers. Together, they
              form the foundation upon which all our decisions should be made.
            </p>
            <p className="text-white">
              Meta Benz's values influence everything that we do, from our
              ongoing relationships with our customers and partners to our daily
              interactions across the business. To cultivate these values within
              the organisation we have ensured that each member of our Team
              Conducts business in line with our values and beliefs. Understands
              our mission to be recognised as a leading Meta Benz and live
              business facilitator in the world through our core values:
            </p>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="img">
            <img
              src="assets/img/resources/homeimg.jpg"
              alt=""
              className="img-responsive img-thumbnail"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* News Section End */}
</>





<SupportedWallets/>


      </>

      





      

    )
}
export default Mainsection;